import React from 'react';

import {ChevronDownIcon} from '../svg-icon';
import {cls} from '../../utils';

import css from './accordion.module.css';

export type AccordionProps = {
	children?: React.ReactNode;
	className?: string;
};

/** Набор раскрывающихся строк: заголовок с краткой подписью, под ним — подробности */
export const Accordion: React.FC<AccordionProps> = ({children, className}) => (
	<div className={cls(css.accordion, className)}>{children}</div>
);

export type AccordionItemProps = {
	/** заголовок строки: всегда виден */
	title: React.ReactNode;
	/** краткое содержание рядом с заголовком; в раскрытой строке прячется, но место за собой оставляет */
	note?: React.ReactNode;
	children?: React.ReactNode;
	/** строка раскрыта с самого начала */
	defaultOpen?: boolean;
	className?: string;
	titleClassName?: string;
	contentClassName?: string;
};

/**
 * Строка на обычном `<details>`: состояние держит браузер, поэтому она раскрывается
 * и до гидрации, и с клавиатуры.
 */
export const AccordionItem: React.FC<AccordionItemProps> = ({
	title,
	note,
	children,
	defaultOpen,
	className,
	titleClassName,
	contentClassName,
}) => (
	<details className={cls(css.item, className)} open={defaultOpen}>
		<summary className={css.summary}>
			<span className={cls(css.title, titleClassName)}>{title}</span>
			{note !== undefined && <span className={css.note}>{note}</span>}
			<ChevronDownIcon className={css.arrow} />
		</summary>
		<div className={cls(css.content, contentClassName)}>{children}</div>
	</details>
);
